import { AmethystClient } from '@/integrations/Immersve/AmethystClient';
import type { Region } from '@/integrations/Immersve/types';

export interface SupportedRegion {
  title: string;
  code: string;
}

export class Regions {
  accountId: string;
  regions: Region[] = [];

  constructor(accountId: string) {
    this.accountId = accountId;
  }

  static forAccount(accountId: string) {
    return new Regions(accountId);
  }

  async load() {
    const response = await new AmethystClient().getSupportedRegions(this.accountId);

    if (!response) {
      throw new Error('No supported regions');
    }

    this.regions = response.regions;
  }

  get availableRegions(): SupportedRegion[] {
    return this.regions
      .filter((region) => region.isAvailable)
      .map((region) => ({ title: region.title, code: region.code }));
  }

  getOnboardingDocuments(regionCode: string) {
    const documents = this.regions.find((r) => r.code === regionCode)?.documents;

    if (!documents || !documents.generalTermsOfUse || !documents.privacyPolicy) {
      throw new Error('Missing user agreements for KYC consent');
    }

    return documents;
  }
}
